/* Garment measurements — Update 2.0.
   Prefers product metafield JSON (custom.garment_measurements + garment_diagram).
   Falls back to prototype samples when metafields are empty/invalid. */
(function () {
  'use strict';

  /* Wording from the reference “How it is measured” column. Length depends on the drawing. */
  var HOW_BY_KEY = {
    chest: 'Straight across the front of the garment at the underarm, seam to seam.',
    waist: 'Straight across the narrowest point of the waist, seam to seam.',
    hip: 'Straight across the widest point below the waist, seam to seam.',
    hem: 'Straight across the bottom opening, edge to edge.',
    rise: 'From the top edge of the waistband down to the crotch seam, at the front.',
    inseam: 'From the crotch seam down the inside leg to the hem.',
    strap_length: 'Along the strap, from the front attachment point to the back.',
    tassel_length: 'From where the fringe begins down to the tip.',
    shoulder: 'From shoulder seam to shoulder seam, across the back.',
    sleeve_length: 'From the shoulder seam to the sleeve hem.',
    sleeve_opening: 'Straight across the sleeve hem, edge to edge.',
    bicep: 'Not currently in use.',
    width: 'Not currently in use.'
  };
  var FOOTWEAR_HOW = {
    length: 'From the back of the heel to the tip of the toe.',
    width: 'Across the widest point of the shoe.',
    heel: 'Vertically at the back, from the ground to where the heel meets the sole.'
  };
  var FOOTWEAR_LABELS = {
    length: 'Length',
    width: 'Width',
    heel: 'Heel'
  };
  var FOOTWEAR_ORDER = ['length', 'width', 'heel'];
  var LENGTH_HOW = {
    centre: 'Measured straight down from the centre front to the lowest point of the hem.',
    waistband: 'Measured straight down from the top edge of the waistband to the lowest point of the hem.',
    high: 'Measured straight down from the highest point of the garment to the lowest point of the hem, not including straps or ties.'
  };

  var SAMPLES = {
    dress: {
      name: 'Silk Slip Dress',
      figure: 'dress',
      sampleSize: 'M',
      unit: 'cm',
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL'],
      rows: [
        { key: 'length', label: 'Length', values: [111.6, 111.9, 112.5, 113.1, 113.7, 114.3] },
        { key: 'chest', label: 'Chest', values: [41.3, 42.5, 45, 47.5, 50, 52.5] },
        { key: 'hip', label: 'Hip', values: [61.25, 62.5, 65, 67.5, 70, 72.5] },
        { key: 'hem', label: 'Hem', values: [98.25, 99.5, 102, 104.5, 107, 109.5] },
        { key: 'strap_length', label: 'Strap Length', values: [75, 75, 75, 75, 75, 75] }
      ]
    },
    pants: {
      name: 'Wide Leg Pant',
      figure: 'pants',
      sampleSize: 'S',
      unit: 'cm',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      rows: [
        { key: 'length', label: 'Length', values: [105, 105.5, 106, 106.5, 107] },
        { key: 'waist', label: 'Waist', values: [33, 35.5, 38, 40.5, 43] },
        { key: 'hip', label: 'Hip', values: [48, 50.5, 53, 55.5, 58] },
        { key: 'rise', label: 'Rise', values: [30, 30.5, 31, 31.5, 32] },
        { key: 'inseam', label: 'Inseam', values: [78, 78.5, 79, 79.5, 80] },
        { key: 'hem', label: 'Hem', values: [28, 28.5, 29, 29.5, 30] }
      ]
    },
    scarf: {
      name: 'Cashmere Scarf',
      figure: 'scarf',
      sampleSize: 'One Size',
      unit: 'cm',
      sizes: ['One Size'],
      rows: [
        { key: 'length', label: 'Length', values: [190] },
        { key: 'width', label: 'Width', values: [65] }
      ]
    }
  };

  var ORDER = ['dress', 'pants', 'scarf'];
  var KNOWN_FIGURES = ['dress', 'dress_center', 'top', 'top_center', 'tshirt', 'long_sleeve', 'skirt', 'pants', 'jacket', 'scarf'];

  function formatNumber(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return String(value);
    var s = n.toFixed(1);
    return s.slice(-2) === '.0' ? s.slice(0, -2) : s;
  }

  function centerLabelOnBar(group, label) {
    if (!group || !label) return;
    var lines = group.querySelectorAll('.gm-mline');
    var span = null;
    var best = 0;
    Array.prototype.forEach.call(lines, function (line) {
      var x1 = parseFloat(line.getAttribute('x1'));
      var y1 = parseFloat(line.getAttribute('y1'));
      var x2 = parseFloat(line.getAttribute('x2'));
      var y2 = parseFloat(line.getAttribute('y2'));
      if (!isFinite(x1) || !isFinite(y1) || !isFinite(x2) || !isFinite(y2)) return;
      var len = Math.hypot(x2 - x1, y2 - y1);
      if (len > best) {
        best = len;
        span = { x1: x1, y1: y1, x2: x2, y2: y2 };
      }
    });
    if (!span || Math.abs(span.y1 - span.y2) > 1) return;
    var anchor = label.getAttribute('text-anchor') || 'start';
    var lx = parseFloat(label.getAttribute('x'));
    var minX = Math.min(span.x1, span.x2);
    var maxX = Math.max(span.x1, span.x2);
    /* A label sitting on the middle of the bar stays clear of the stroke. */
    if (anchor === 'middle' && lx >= minX && lx <= maxX) return;
    label.setAttribute('y', String((span.y1 + span.y2) / 2));
    label.setAttribute('dominant-baseline', 'central');
  }

  /* Labels stay the table’s font size on screen, whatever the diagram scale. */
  function syncDiagramLabelSize(svg, root) {
    if (!svg) return;
    var vb = svg.viewBox && svg.viewBox.baseVal;
    var rect = svg.getBoundingClientRect();
    if (!vb || !vb.height || rect.height < 1) return;
    var sample = root.querySelector('.garment-measurements-table th, .garment-measurements-table td, .scr-table th, .scr-table td');
    var screenPx = 13;
    if (sample) {
      var parsed = parseFloat(window.getComputedStyle(sample).fontSize);
      if (parsed) screenPx = parsed;
    }
    var userPx = screenPx * (vb.height / rect.height);
    Array.prototype.forEach.call(svg.querySelectorAll('.gm-mlabel'), function (label) {
      label.style.fontSize = userPx + 'px';
    });
  }

  function howFor(figure, row, footwear) {
    if (row && row.how) return row.how;
    if (footwear && row && FOOTWEAR_HOW[row.key]) return FOOTWEAR_HOW[row.key];
    if (row && row.key === 'length') {
      if (figure === 'dress_center' || figure === 'top_center') return LENGTH_HOW.centre;
      if (figure === 'skirt' || figure === 'pants') return LENGTH_HOW.waistband;
      return LENGTH_HOW.high;
    }
    if (row && HOW_BY_KEY[row.key]) return HOW_BY_KEY[row.key];
    return 'Measured with the garment laid flat, without stretching.';
  }

  var FLAT_NOTE = 'Measurements are specific to this style and are taken with the garment laid flat.';

  function showFlatNote(note) {
    if (!note) return;
    note.hidden = false;
    note.textContent = FLAT_NOTE;
  }

  /* Short end crosses are about 28 user units. The measurement span is longer. */
  function markEndTicks(group) {
    Array.prototype.forEach.call(group.querySelectorAll('.gm-mline'), function (line) {
      if (line.tagName.toLowerCase() !== 'line') return;
      var x1 = parseFloat(line.getAttribute('x1'));
      var y1 = parseFloat(line.getAttribute('y1'));
      var x2 = parseFloat(line.getAttribute('x2'));
      var y2 = parseFloat(line.getAttribute('y2'));
      if (!isFinite(x1) || !isFinite(y1) || !isFinite(x2) || !isFinite(y2)) return;
      if (Math.hypot(x2 - x1, y2 - y1) <= 40) line.classList.add('gm-mtick');
    });
  }

  /* Transparent wider strokes so thin dashed lines are easy to click. */
  function ensureHitTargets(group) {
    if (!group || group.getAttribute('data-gm-hit') === 'true') return;
    var lines = group.querySelectorAll('.gm-mline');
    Array.prototype.forEach.call(lines, function (line) {
      var hit = line.cloneNode(false);
      hit.removeAttribute('class');
      hit.setAttribute('class', 'gm-mhit');
      hit.removeAttribute('stroke-dasharray');
      group.insertBefore(hit, line);
    });
    group.setAttribute('data-gm-hit', 'true');
  }

  function parseConfig(root) {
    var el = root.querySelector('[data-gm-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function validateMeasurements(data) {
    if (!data || typeof data !== 'object') return null;
    if (!Array.isArray(data.sizes) || !data.sizes.length) return null;
    if (!Array.isArray(data.rows) || !data.rows.length) return null;

    for (var i = 0; i < data.rows.length; i++) {
      var row = data.rows[i];
      if (!row || !row.key || !row.label || !Array.isArray(row.values)) return null;
      if (row.values.length !== data.sizes.length) return null;
      for (var j = 0; j < row.values.length; j++) {
        if (typeof row.values[j] !== 'number' || isNaN(row.values[j])) return null;
      }
    }
    return data;
  }

  function normaliseFigure(figure) {
    if (figure == null || String(figure).trim() === '') return '';
    var f = String(figure).trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (f === 'pant') f = 'pants';
    if (f === 't_shirt' || f === 'tee') f = 'tshirt';
    if (f === 'dress_centre') f = 'dress_center';
    if (f === 'top_centre') f = 'top_center';
    if (f === 'longsleeve') f = 'long_sleeve';
    if (KNOWN_FIGURES.indexOf(f) === -1) return null;
    return f;
  }

  function pickSize(sizes, preferred) {
    if (preferred && sizes.indexOf(preferred) !== -1) return preferred;
    if (sizes.indexOf('M') !== -1) return 'M';
    return sizes[Math.floor(sizes.length / 2)] || sizes[0];
  }

  function rowIsValid(row, sizeCount) {
    if (!row || !row.key || !Array.isArray(row.values)) return false;
    if (row.values.length !== sizeCount) return false;
    for (var j = 0; j < row.values.length; j++) {
      if (typeof row.values[j] !== 'number' || isNaN(row.values[j])) return false;
    }
    return true;
  }

  function validateFootwear(data) {
    if (!data || typeof data !== 'object') return null;
    if (!Array.isArray(data.sizes) || !data.sizes.length) return null;
    if (!Array.isArray(data.rows)) return null;

    var rows = [];
    for (var i = 0; i < data.rows.length; i++) {
      var row = data.rows[i];
      if (!rowIsValid(row, data.sizes.length)) continue;
      if (!row.label && FOOTWEAR_LABELS[row.key]) row.label = FOOTWEAR_LABELS[row.key];
      if (!row.label) continue;
      rows.push(row);
    }
    rows.sort(function (a, b) {
      var ia = FOOTWEAR_ORDER.indexOf(a.key);
      var ib = FOOTWEAR_ORDER.indexOf(b.key);
      if (ia < 0) ia = 99;
      if (ib < 0) ib = 99;
      return ia - ib;
    });
    if (!rows.length) return null;
    return {
      unit: data.unit,
      sizes: data.sizes,
      rows: rows
    };
  }

  function productFromMetafield(config) {
    var measurements = config.footwear
      ? validateFootwear(config.measurements)
      : validateMeasurements(config.measurements);
    if (!measurements) return null;

    var normalised = normaliseFigure(config.diagram);
    var figure = normalised === '' ? 'dress' : normalised;
    if (config.footwear) figure = normalised || '';
    return {
      name: config.productTitle || 'Product',
      figure: figure,
      sampleSize: pickSize(measurements.sizes, config.selectedSize),
      unit: measurements.unit || 'cm',
      sizes: measurements.sizes,
      rows: measurements.rows,
      source: 'metafield',
      footwear: !!config.footwear
    };
  }

  function GarmentMeasurementD20() {
    this.root = null;
    this.mode = 'sample';
    this.liveProduct = null;
    this.productKey = ORDER[0];
    this.unit = 'cm';
    this.activeSize = null;
    this.activeRow = null;
  }

  GarmentMeasurementD20.prototype.product = function () {
    if (this.mode === 'empty') return null;
    if (this.mode === 'metafield' && this.liveProduct) return this.liveProduct;
    return SAMPLES[this.productKey];
  };

  GarmentMeasurementD20.prototype.convert = function (cm) {
    return this.unit === 'cm' ? cm : cm / 2.54;
  };

  GarmentMeasurementD20.prototype.init = function (rootEl) {
    var el = rootEl || document.querySelector('[data-garment-measurement-d20]');
    if (!el) return;

    if (el.getAttribute('data-gm-ready') === 'true') {
      this.root = el;
      this.render();
      return;
    }

    this.root = el;
    this.head = el.querySelector('[data-gm-head]');
    this.body = el.querySelector('[data-gm-body]');
    this.howto = el.querySelector('[data-gm-howto]');
    this.visual = el.querySelector('[data-gm-visual]');
    this.sr = el.querySelector('[data-gm-sr]');
    this.note = el.querySelector('[data-gm-note]');
    this.proto = el.querySelector('[data-gm-proto]');

    var config = parseConfig(el);
    var live = config && config.hasMetafield ? productFromMetafield(config) : null;

    if (live) {
      this.mode = 'metafield';
      this.liveProduct = live;
      this.unit = live.unit === 'in' ? 'in' : 'cm';
      this.activeSize = live.sampleSize;
      this.activeRow = live.rows[0].key;
      if (this.proto) this.proto.setAttribute('hidden', 'hidden');
      if (live.footwear) {
        if (this.note) this.note.hidden = true;
      } else {
        showFlatNote(this.note);
      }
    } else if (config && config.hasMetafield) {
      /* Liquid thought data existed but JSON failed validation — stay empty, no samples. */
      this.mode = 'empty';
      if (this.proto) this.proto.setAttribute('hidden', 'hidden');
      if (this.note) {
        this.note.hidden = false;
        this.note.textContent = 'Garment measurements are unavailable for this style.';
      }
    } else {
      this.mode = 'sample';
      this.buildProductChoices();
      this.loadProduct(this.productKey);
      if (this.proto) this.proto.removeAttribute('hidden');
      showFlatNote(this.note);
    }

    this.bindUnits();
    this.bindFigure();
    this.render();
    el.setAttribute('data-gm-ready', 'true');
  };

  GarmentMeasurementD20.prototype.buildProductChoices = function () {
    var self = this;
    var holder = this.root.querySelector('[data-gm-products]');
    if (!holder) return;

    holder.innerHTML = '';
    ORDER.forEach(function (key) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gm-mock__proto-btn';
      btn.textContent = SAMPLES[key].name;
      btn.setAttribute('data-gm-product', key);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.loadProduct(key);
      });
      holder.appendChild(btn);
    });
  };

  GarmentMeasurementD20.prototype.bindUnits = function () {
    var self = this;
    var links = this.root.querySelectorAll('[data-gm-unit]');
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.unit = link.getAttribute('data-gm-unit');
        Array.prototype.forEach.call(links, function (l) {
          var on = l === link;
          l.classList.toggle('is-active', on);
          l.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        self.render();
      });
    });
  };

  /* Diagram → table: click any visible measurement line/label to select that row. */
  GarmentMeasurementD20.prototype.bindFigure = function () {
    var self = this;
    if (!this.visual) return;

    this.visual.addEventListener('click', function (e) {
      var group = e.target.closest && e.target.closest('[data-gm]');
      if (!group || group.hasAttribute('hidden')) return;

      var key = group.getAttribute('data-gm');
      if (!key) return;

      var product = self.product();
      if (!product) return;

      var match = null;
      for (var i = 0; i < product.rows.length; i++) {
        if (product.rows[i].key === key) { match = product.rows[i]; break; }
      }
      if (!match) return;

      e.preventDefault();
      e.stopPropagation();
      self.activeRow = key;
      self.render();
    });
  };

  GarmentMeasurementD20.prototype.loadProduct = function (key) {
    if (!SAMPLES[key]) return;
    this.mode = 'sample';
    this.productKey = key;

    var product = this.product();
    this.activeSize = product.sampleSize;
    this.activeRow = product.rows.length ? product.rows[0].key : null;

    var buttons = this.root.querySelectorAll('[data-gm-product]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-gm-product') === key);
    });

    this.render();
  };

  GarmentMeasurementD20.prototype.render = function () {
    if (!this.root) return;
    this.renderTable();
    this.renderFigure();
    this.renderHowTo();
  };

  GarmentMeasurementD20.prototype.renderTable = function () {
    var self = this;
    var product = this.product();
    if (!product) return;
    var sizeIndex = product.sizes.indexOf(this.activeSize);

    this.head.innerHTML = '';
    var corner = document.createElement('th');
    corner.textContent = 'Size (' + (this.unit === 'cm' ? 'cm' : 'in') + ')';
    this.head.appendChild(corner);

    product.sizes.forEach(function (size) {
      var th = document.createElement('th');
      th.textContent = size;
      th.className = 'gm-table-size-h ' + (size === self.activeSize ? 'is-col-active' : 'is-col-inactive');
      th.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.activeSize = size;
        self.render();
      });
      self.head.appendChild(th);
    });

    this.body.innerHTML = '';
    product.rows.forEach(function (row) {
      var tr = document.createElement('tr');

      var label = document.createElement('td');
      label.textContent = row.label;
      label.className = 'gm-table-type-label ' + (row.key === self.activeRow ? 'is-row-active' : 'is-row-inactive');
      label.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.activeRow = row.key;
        self.render();
      });
      tr.appendChild(label);

      row.values.forEach(function (value, i) {
        var td = document.createElement('td');
        td.textContent = formatNumber(self.convert(value));
        td.className = 'gm-table-size-cell ' + (i === sizeIndex ? 'is-col-active' : 'is-col-inactive');
        td.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.activeRow = row.key;
          self.activeSize = product.sizes[i];
          self.render();
        });
        tr.appendChild(td);
      });

      self.body.appendChild(tr);
    });
  };

  GarmentMeasurementD20.prototype.renderFigure = function () {
    var self = this;
    var product = this.product();
    if (!product || !this.visual) return;

    var sizeIndex = product.sizes.indexOf(this.activeSize);
    var suffix = this.unit === 'cm' ? 'cm' : 'in';
    var figure = product.figure;
    var hasSvg = !!this.visual.querySelector('[data-gm-figure="' + figure + '"]');

    var figures = this.visual.querySelectorAll('[data-gm-figure]');
    Array.prototype.forEach.call(figures, function (svg) {
      if (hasSvg && svg.getAttribute('data-gm-figure') === figure) {
        svg.removeAttribute('hidden');
      } else {
        svg.setAttribute('hidden', 'hidden');
      }
    });

    this.visual.classList.toggle('is-figure-missing', !hasSvg);
    if (!hasSvg) {
      this.visual.classList.remove('is-figure-dress', 'is-figure-jacket', 'is-figure-pants', 'is-figure-tshirt', 'is-figure-longsleeve', 'is-figure-skirt', 'is-figure-top');
      return;
    }

    this.visual.classList.toggle('is-figure-dress', figure === 'dress' || figure === 'dress_center');
    this.visual.classList.toggle('is-figure-jacket', figure === 'jacket');
    this.visual.classList.toggle('is-figure-pants', figure === 'pants');
    this.visual.classList.toggle('is-figure-tshirt', figure === 'tshirt');
    this.visual.classList.toggle('is-figure-longsleeve', figure === 'long_sleeve');
    this.visual.classList.toggle('is-figure-skirt', figure === 'skirt');
    this.visual.classList.toggle('is-figure-top', figure === 'top' || figure === 'top_center');

    var active = this.visual.querySelector('[data-gm-figure="' + figure + '"]');
    Array.prototype.forEach.call(active.querySelectorAll('[data-gm]'), function (group) {
      group.setAttribute('hidden', 'hidden');
      group.classList.remove('is-active');
      var label = group.querySelector('.gm-mlabel');
      if (label) label.textContent = '';
    });

    product.rows.forEach(function (row) {
      var group = active.querySelector('[data-gm="' + row.key + '"]');
      if (!group) return;
      group.removeAttribute('hidden');
      group.classList.toggle('is-active', row.key === self.activeRow);
      markEndTicks(group);
      ensureHitTargets(group);
      var label = group.querySelector('.gm-mlabel');
      if (label && sizeIndex > -1) {
        label.textContent = formatNumber(self.convert(row.values[sizeIndex])) + suffix;
        centerLabelOnBar(group, label);
      }
    });
    syncDiagramLabelSize(active, this.root);
  };

  GarmentMeasurementD20.prototype.renderHowTo = function () {
    var product = this.product();
    if (!product || !this.howto) return;

    var row = null;
    for (var i = 0; i < product.rows.length; i++) {
      if (product.rows[i].key === this.activeRow) { row = product.rows[i]; break; }
    }
    if (!row) return;

    this.howto.innerHTML =
      '<b>' + row.label + '</b>' + howFor(product.figure, row, product.footwear);

    if (this.sr) {
      var sizeIndex = product.sizes.indexOf(this.activeSize);
      this.sr.textContent = product.name + ', size ' + this.activeSize + ', ' +
        row.label + ' ' + formatNumber(this.convert(row.values[sizeIndex])) +
        (this.unit === 'cm' ? ' centimetres' : ' inches');
    }
  };

  var instances = [];

  function initRoot(rootEl) {
    if (!rootEl) return null;
    var existing = null;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root === rootEl) {
        existing = instances[i];
        break;
      }
    }
    if (existing) {
      existing.render();
      return existing;
    }
    var inst = new GarmentMeasurementD20();
    inst.init(rootEl);
    if (inst.root) instances.push(inst);
    return inst;
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-garment-measurement-d20]');
    Array.prototype.forEach.call(roots, function (el) {
      initRoot(el);
    });
  }

  window.StAgniGarmentMeasurementD20 = {
    init: initRoot,
    initAll: initAll,
    instances: instances
  };

  function boot() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.sizechart-tab, .sizeguide-prototype-tab, [data-action="open-modal"], [data-action="open-size-guide-drawer"]')) {
      setTimeout(boot, 50);
    }
  });
})();
